// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"eac10d51","424":"8ca66123"}[chunkId] + ".chunk.js";
};